import { jsx as t, Fragment as o } from "react/jsx-runtime";
import { useEffect as m } from "react";
import { initAuth as e } from "./listener.es.js";
const p = ({ children: r }) => (m(() => {
  e();
}, []), /* @__PURE__ */ t(o, { children: r }));
export {
  p as AuthProvider
};
